import { OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';
var DemoComponent = /** @class */ (function () {
    function DemoComponent(deviceService, route) {
        this.deviceService = deviceService;
        this.route = route;
        this.isStarted = false;
        this.validToken = false;
        this.isLoading = false;
        this.startLevel = 2;
        this.endLevel = 5;
        this.variantId = 11;
        this.language = 1; // default DE
        this.lang = 'de';
    }
    DemoComponent.prototype.ngOnInit = function () {
        var _this = this;
        // detect mobile
        this.mobileMode = this.deviceService.isMobile();
        console.log('is mobile device: ' + this.mobileMode);
        // generate style
        this.clozeTestStyleModel = this.generateClozeTestStyle();
        // sett logo and button color
        this.cTestLogo = 'onset-assets/img/onset_logo.png';
        this.cTestButtonColor = this.clozeTestStyleModel.onsetColor;
        // callback for query parameter
        this.route.queryParams.subscribe(function (params) {
            _this.isLoading = true;
            if (params['token']) {
                var token = params['token'];
                if (token === 'DEMO-91034f05-f5b9-459e-a5d1-03db1215eb59') {
                    _this.validToken = true;
                }
            }
            if (params['lang'] === 'en') {
                _this.language = 2;
                _this.lang = 'en';
            }
            _this.isLoading = false;
        });
    };
    DemoComponent.prototype.startOnset = function () {
        this.clozeTestModel = this.generateClozeTestModel();
        this.clozeTestStyleModel = this.generateClozeTestStyle();
        this.isStarted = true;
    };
    DemoComponent.prototype.onStartTest = function (start) {
        console.log("test started");
    };
    DemoComponent.prototype.onBookingInit = function (gastBookingId) {
        this.gastBookingId = gastBookingId;
        console.log("init gastBookingId " + gastBookingId);
    };
    DemoComponent.prototype.onTestHasBeenSaved = function (gastBookingId) {
        this.gastBookingId = gastBookingId;
        console.log("saving gastBookingId " + gastBookingId);
    };
    DemoComponent.prototype.onClozeTestCompleted = function () {
        console.log("test completed");
    };
    DemoComponent.prototype.onTestResult = function (test) {
        console.log("next test result " + test);
    };
    DemoComponent.prototype.generateClozeTestModel = function () {
        var onsetServiceUrl = 'https://apprex.gast.de/gast-service-onset/';
        var clozeTestModel = {};
        clozeTestModel.getResultsUrl = onsetServiceUrl + 'api/score';
        clozeTestModel.postTestUrl = onsetServiceUrl + 'api/aufgabe/save';
        clozeTestModel.getTestUrl = onsetServiceUrl + 'api/aufgabe';
        clozeTestModel.getNextTestUrl = onsetServiceUrl + 'api/aufgabe/next';
        clozeTestModel.startWithBuchungId = this.gastBookingId;
        clozeTestModel.urlParameters = {
            herkunft: 'deutschland',
            geschlecht: 'm',
            geburtsdatum: '1990-01-01',
            variante: this.variantId,
            testzentrum: 454,
            sprache: this.language,
            tool: 1,
            start_level: this.startLevel,
            end_level: this.endLevel
        };
        return clozeTestModel;
    };
    DemoComponent.prototype.generateClozeTestStyle = function () {
        var model = {};
        model.siteBackground = '#ffffff';
        model.exerciseBackground = '#EEF3F8';
        model.frameColor = '#92aac1';
        model.barColor = '#b3c9de';
        model.specialCharacterListColor = '#b3c9de';
        model.specialChcaracterTextColor = '#000000';
        model.exerciseTextColor = '#000000';
        model.buttonsColor = '#fa9463';
        model.testdafColor = '#57a7d6';
        model.onsetColor = '#a5d8db';
        model.duoColor = '#ed6a5b';
        model.testasColor = '#fac075';
        model.font = 'arial, helvetica, sans-serif';
        model.fontSize = '11pt';
        model.displayLogo = true;
        if (this.lang === 'de') {
            model.cTestInformationUrl = 'https://de.wikipedia.org/wiki/Gemeinsamer_europ%C3%A4ischer_Referenzrahmen_f%C3%BCr_Sprachen';
        }
        else if (this.lang === 'en') {
            model.cTestInformationUrl = 'https://en.wikipedia.org/wiki/Common_European_Framework_of_Reference_for_Languages';
        }
        else {
            model.cTestInformationUrl = 'https://en.wikipedia.org/wiki/Common_European_Framework_of_Reference_for_Languages';
        }
        return model;
    };
    return DemoComponent;
}());
export { DemoComponent };
